import axios from 'axios';

import { API_URL } from '../../../../setup/config/env';

export function createDocument(document) {
  return dispatch => {
    return axios.post(`${API_URL}/api/document`, document);
  };
}

export function updateDocument(id, updates) {
  return dispatch => {
    return axios.put(`${API_URL}/api/document/${id}`, updates);
  };
}

export function removeDocument(id, type) {
  return dispatch => {
    return axios.delete(`${API_URL}/api/document/${id}`, { params: { type } });
  };
}

export function documentPublishToggle(id, isPublished) {
  return dispatch => {
    return axios.post(`${API_URL}/api/document/publish-toggle/${id}`, { isPublished });
  };
}
